import {
  CASHMANAGE_ADD_MODAL_SHOW,
  CASHMANAGE_IS_REGISTOROPEN,
  CASHMANAGE_IS_REGISTOR_LOADING,
  OPENCLOSE_STORE_OUTLETS,
  OPENCLOSE_SELECTED_STORE_OUTLETS,
  OPENCLOSE_OUTLETS_REGISTERS,
  OPENCLOSE_SELECTED_OUTLETS_REGISTERS,
  OPENCLOSE_REGOUTLETS_LOADING,
  OPENCLOSE_CLOSEDREG_LOADING,
  OPENCLOSE_CLOSEDREG_DATA,
  OPENCLOSE_CASHLISTING_LOADING,
  OPENCLOSE_CASHLIST_DATALOAD,
  OPENCLOSE_LISTING_DATALOAD,
  SALEHISTORY_CUSTOMER_SHOW,
  SALEHISTORY_CUSTOMER_LOAD,
  SEND_EMAIL_MODAL_SHOW,
  STORE_USERS,
  SELL_SCREEN_LOADING,
  SELL_PRODUCT_DETAIL,
  SELL_VARIANTS_PRODUCT,
  SELL_SELECTED_PRODUCTS,
  SELL_SELECTED_SINGLE_PRODUCT,
  SALE_PRICEBOOKS,
  SALE_PROMOTIONS,
  CUSTOMERS_SEARCH_DATA,
  USER_SUBS_INFO,
  SHOW_COMPLETE_SALE,
  SALE_PRODUCT_JSON,
  SALE_PAYMENT_DATA,
  CUSTOMERS_SEARCH_DATA_FOR_HISTORY,
  IS_SALE_PAYMENT_DONE,
  CURRENT_SALES_ORDER_DATA,
  CURRENT_ORDER_GUID_ID,
  CURRENT_SALES_ORDER_STATUS_DATA,
  IS_DISCARD_SALE,
  REFUND_SALE_STATUS,
  SALE_PROGRESS_MODAL_SHOW,
  TEMP_SALES_ORDER_DATA,
  IS_SHOW_RETURN_DIALOG,
  CHILD_DATA,
  IS_FILTER_SALE_CALL,
  FILTER_SALE_ID,
  LOAD_ATTRIBUTE_DATA,
  SELLATTRIBUTES,
  ISSHOWSELLATTRIBUTE,
  SELLATTRIBUTESGROUPS,
  SELLATTRIBUTELOADING,
  SELLSELECTEDATTRIBUTES,
  PRODSVARIANTS,
  INVENTORYPOPUP,
  SELLACTIONLOG,
  ShowNumpad,
  NumPadType,
  NumRelateData,
  NumDataChange,
  MOUNTSELLATTRIBTABS,
  MOUNTSELLATTRIBTABS_TYPE,
  SHOW_QUICK_KEY,
  ShowNumpadForDiscount,
  ShowNumpadForPayment
} from '../../constants/ActionTypes'
import { loadIsProductLoading } from './MainSale'
import { loadIsOutletInvWarn } from './CommonData'
import ds from '../../Services/DataServices'
import { message } from 'antd'
import { userLogOut } from './Auth'
import {
  CURRENT_VERSION,
  INDEX_DB_NAME,
  INDEX_DB_SALE_ATTRIB_COLUMNS,
  INDEX_DB_TABLES,
  SALE_ATTRIB_NAME_INDEX
} from '../../constants/IndexDBData'
import {
  GetIndexDBDataByTableName,
  saveEntitiesDatatoIndexBD,
  saveUpdateEntitiesToIndexedDB
} from './IndexDBActions'
import {
  fetchInfoForProdJson,
  getAllParkedIndexedSales,
  loadIndexDBSellAttribGroups,
  loadIndexDBSellAttributes,
  prodDetailStatic
} from './saleIndexDB'
import {
  checkExpiresSub,
  checkUserVerifyPage,
  fetchCurrentSalesOrder,
  getDecryptID,
  isEmptyObject
} from '.'
import { getPromoFromIndexDB } from './saleIndexDB'
import { getPriceBookFromIndexDB } from './saleIndexDB'
import { CONFIG_LOGS } from '../../constants/IndexDB_Logs'
import { postDataToApp } from './MobAppFn'
import { PostAppTypes } from '../../constants/MobAppConstants'

//**********CASH_MANAGEMENT************

export function loadAddCashModalShow (loadValue) {
  return dispatch => {
    dispatch({ type: CASHMANAGE_ADD_MODAL_SHOW, payload: loadValue })
  }
}

export function loadIsRegistorOpen (loadValue) {
  return dispatch => {
    dispatch({ type: CASHMANAGE_IS_REGISTOROPEN, payload: loadValue })
  }
}

export function loadIsRegistorLoading (loadValue) {
  return dispatch => {
    dispatch({ type: CASHMANAGE_IS_REGISTOR_LOADING, payload: loadValue })
  }
}

export function loadCashListingLoading (loadValue) {
  return dispatch => {
    dispatch({ type: OPENCLOSE_CASHLISTING_LOADING, payload: loadValue })
  }
}

export function loadCashListingDataLoading (loadValue) {
  return dispatch => {
    dispatch({ type: OPENCLOSE_CASHLIST_DATALOAD, payload: loadValue })
  }
}

//**********OPEN_CLOSE************

export function loadStoreOutlets (isUserAccordingly) {
  return async (dispatch, store) => {
    if (!checkUserVerifyPage()) {
      storeOutletsService(dispatch, isUserAccordingly)
    }
  }
}

export function loadSelectedStoreOutlets (loadValue) {
  return dispatch => {
    dispatch({ type: OPENCLOSE_SELECTED_STORE_OUTLETS, payload: loadValue })
    postDataToApp(PostAppTypes.OUTLET, loadValue)
  }
}

export function loadOutletRegisters (body, isOnline) {
  return (dispatch, store) => {
    if (true) outletRegisterService(dispatch, body)
    // NOTE: online is always true just because the register selection will always be when system is online
    else getOutRegFromIndex(dispatch)
  }
}

export function loadSelectedOutletRegisters (loadValue) {
  return dispatch => {
    dispatch({
      type: OPENCLOSE_SELECTED_OUTLETS_REGISTERS,
      payload: loadValue
    })
    postDataToApp(PostAppTypes.REGISTER, loadValue)
  }
}

export function loadRegOutletsLoading (loadValue) {
  return dispatch => {
    dispatch({ type: OPENCLOSE_REGOUTLETS_LOADING, payload: loadValue })
  }
}

export function loadClosedRegLoading (loadValue) {
  return dispatch => {
    dispatch({ type: OPENCLOSE_CLOSEDREG_LOADING, payload: loadValue })
  }
}

export function loadClosedRegData (body, isDirect) {
  return dispatch => {
    if (isDirect) {
      dispatch({ type: OPENCLOSE_CLOSEDREG_DATA, payload: body })
    } else {
      closedRegisterService(dispatch, body)
    }
  }
}

export function loadOpenCloseListingDataLoad (loadValue) {
  return dispatch => {
    dispatch({ type: OPENCLOSE_LISTING_DATALOAD, payload: loadValue })
  }
}

//**********SALE_HISTORY************

export function loadSaleHistoryCustomerShow (loadValue) {
  return dispatch => {
    dispatch({ type: SALEHISTORY_CUSTOMER_SHOW, payload: loadValue })
  }
}

export function loadSaleHistoryCustomerLoad (loadValue) {
  return dispatch => {
    dispatch({ type: SALEHISTORY_CUSTOMER_LOAD, payload: loadValue })
  }
}

export function loadSendEmailModalShow (loadValue) {
  return dispatch => {
    dispatch({ type: SEND_EMAIL_MODAL_SHOW, payload: loadValue })
  }
}

export function loadStoreUsers () {
  return (dispatch, store) => {
    // let regData = [];
    storeUsersService(dispatch)
  }
}

//**********SELL_SCREEN************

export function loadSellProductDetails (
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  isNetOn,
  outID,
  user
) {
  return dispatch => {
    if (isNetOn) {
      sellProductDetailService(
        dispatch,
        body,
        prevValue,
        selectedProds,
        outInvWarn,
        user
      )
    } else {
      const data = GetIndexDBDataByTableName(
        INDEX_DB_NAME,
        // INDEX_DB_TABLES.PROD_DETAIL
        INDEX_DB_TABLES.SALEPRODUCTS
      )
      data
        .then(e => {
          if (e && e.length > 0) {
            let prods = []
            if (body && body.containVariants) {
              prods = e.filter(
                a => a.parentProductID == getDecryptID(body.productID)
              )
            } else {
              prods = e.filter(
                a => getDecryptID(a.sProductID) == getDecryptID(body.productID)
              )
            }

            if (prods && prods.length > 0) {
              fetchInfoForProdJson(
                prods,
                outID,
                dispatch,
                body,
                prevValue,
                selectedProds,
                outInvWarn,
                user
              )

              // const respBody = {
              //   variants: prod[0].variants,
              //   products: prod,
              //   parentProdID: prod[0].parentProdID
              // }
              // buildProdForCart(
              //   respBody,
              //   dispatch,
              //   body,
              //   prevValue,
              //   selectedProds,
              //   outInvWarn
              // )
            } else console.log('INDEX_DB_ERROR: Product not found in indexDB')
          }
        })
        .catch(e => {
          console.log('INDEX_DB -> loadSellProductDetails -->', e)
        })
    }
  }
}

export function loadSellScreenLoading (loadValue) {
  return dispatch => {
    dispatch({ type: SELL_SCREEN_LOADING, payload: loadValue })
  }
}

export function loadSellVariantProd (loadValue, isVariant) {
  return dispatch => {
    if (isVariant) {
      dispatch({ type: SELL_VARIANTS_PRODUCT, payload: loadValue })
    } else {
      dispatch({ type: SELL_PRODUCT_DETAIL, payload: loadValue })
    }
  }
}

export function loadSellSelectedProds (loadValue) {
  return dispatch => {
    dispatch({ type: SELL_SELECTED_PRODUCTS, payload: loadValue })
  }
}

export function loadSellSelectedSingleProd (loadValue) {
  return dispatch => {
    dispatch({ type: SELL_SELECTED_SINGLE_PRODUCT, payload: loadValue })
  }
}

export function loadCustomerSearchData (loadValue) {
  return dispatch => {
    dispatch({ type: CUSTOMERS_SEARCH_DATA, payload: loadValue })
  }
}

export function loadCustomerSearchDataForHistory (loadValue) {
  return dispatch => {
    dispatch({ type: CUSTOMERS_SEARCH_DATA_FOR_HISTORY, payload: loadValue })
  }
}

export function loadIsShowCompleteSale (loadValue) {
  return dispatch => {
    dispatch({ type: SHOW_COMPLETE_SALE, payload: loadValue })
  }
}

export function loadUserSubInfo (loadValue) {
  return dispatch => {
    getUserSubscriptionInfo(dispatch)
  }
}

export function loadSalePriceBooks (outletID, isOnline) {
  return dispatch => {
    if (isOnline) salePriceBooksService(dispatch, outletID)
    else getPriceBookFromIndexDB(dispatch, outletID)
  }
}

export function loadSalePromotions (outletID, isOnline) {
  return dispatch => {
    if (isOnline) salePromotionsService(dispatch, outletID)
    else getPromoFromIndexDB(dispatch, outletID)
  }
}

export function loadSaleProductJsonData (loadValue) {
  return dispatch => {
    dispatch({ type: SALE_PRODUCT_JSON, payload: loadValue })
  }
}

export function loadSalePaymentData (loadValue) {
  return dispatch => {
    dispatch({ type: SALE_PAYMENT_DATA, payload: loadValue })
  }
}

export function loadRegOfSelectedOut (loadValue) {
  return dispatch => {
    dispatch({ type: OPENCLOSE_OUTLETS_REGISTERS, payload: loadValue })
  }
}

export function loadSalePaymentStatus (loadValue) {
  return dispatch => {
    dispatch({ type: IS_SALE_PAYMENT_DONE, payload: loadValue })
  }
}

// export function loadCurrentSalesOrderData(loadValue,isLoadData) {
//   if(isLoadData!=undefined){
//     if(isLoadData){
//       return (dispatch) => {
//         dispatch({ type: CURRENT_SALES_ORDER_DATA , payload: loadValue });
//       };
//     }
//     else{
//       return (dispatch) => {
//         getSalesOrderDataService(dispatch, loadValue);
//       };
//     }
//   }
//   else{
//     return (dispatch) => {
//       getSalesOrderDataService(dispatch, loadValue);
//     };
//   }

// }

export function loadCurrentSalesOrderData (loadValue) {
  return dispatch => {
    dispatch({ type: CURRENT_SALES_ORDER_DATA, payload: loadValue })
  }
}

export function loadCurrentOrderGuidID (loadValue) {
  return dispatch => {
    dispatch({ type: CURRENT_ORDER_GUID_ID, payload: loadValue })
  }
}

export function loadCurrentSalesOrderStatusData (loadValue) {
  return dispatch => {
    dispatch({ type: CURRENT_SALES_ORDER_STATUS_DATA, payload: loadValue })
  }
}

export function loadIsDiscardSale (loadValue) {
  return dispatch => {
    dispatch({ type: IS_DISCARD_SALE, payload: loadValue })
  }
}

export function loadRefundSaleStatus (loadValue) {
  return dispatch => {
    dispatch({ type: REFUND_SALE_STATUS, payload: loadValue })
  }
}

export function loadSaleProgressModalShow (loadValue) {
  return dispatch => {
    dispatch({ type: SALE_PROGRESS_MODAL_SHOW, payload: loadValue })
  }
}

export function loadTempSalesOrderData (loadValue) {
  return dispatch => {
    dispatch({ type: TEMP_SALES_ORDER_DATA, payload: loadValue })
  }
}

export function loadIsShowReturnDialog (loadValue) {
  return dispatch => {
    dispatch({ type: IS_SHOW_RETURN_DIALOG, payload: loadValue })
  }
}

export function loadChildData (loadValue) {
  return dispatch => {
    dispatch({ type: CHILD_DATA, payload: loadValue })
  }
}

export function loadIsFilterCall (loadValue) {
  return dispatch => {
    dispatch({ type: IS_FILTER_SALE_CALL, payload: loadValue })
  }
}

export function loadFilterSaleID (loadValue) {
  return dispatch => {
    dispatch({ type: FILTER_SALE_ID, payload: loadValue })
  }
}

export function loadSellAttributeData (loadValue) {
  return dispatch => {
    dispatch({ type: LOAD_ATTRIBUTE_DATA, payload: loadValue })
  }
}

export function loadSellAttributes (body, isOnline) {
  return dispatch => {
    if (isOnline) getSellAttributes(dispatch, body)
    else getAllParkedIndexedSales(dispatch, body)
  }
}

export function loadSellAttributesGroups (isOnline) {
  return dispatch => {
    if (isOnline) getSellAttributesGroups(dispatch)
    else loadIndexDBSellAttribGroups(dispatch)
  }
}

export function loadIsShowSellAttribute (loadValue) {
  return dispatch => {
    dispatch({ type: ISSHOWSELLATTRIBUTE, payload: loadValue })
  }
}

export function loadSellAttributeLoading (loadValue) {
  return dispatch => {
    dispatch({ type: SELLATTRIBUTELOADING, payload: loadValue })
  }
}

export function loadSellSelectedAttributes (loadValue) {
  return dispatch => {
    dispatch({ type: SELLSELECTEDATTRIBUTES, payload: loadValue })
  }
}

export function loadCheckProdsVariants (loadValue) {
  return dispatch => {
    dispatch({ type: PRODSVARIANTS, payload: loadValue })
  }
}

export function loadShowInventoryPopup (loadValue) {
  return dispatch => {
    dispatch({ type: INVENTORYPOPUP, payload: loadValue })
  }
}

export function loadActionLogs (loadValue) {
  return dispatch => {
    dispatch({ type: SELLACTIONLOG, payload: loadValue })
  }
}

export function loadShowNumPad (loadValue) {
  return dispatch => {
    dispatch({ type: ShowNumpad, payload: loadValue })
  }
}

export function loadShowNumPadForDiscount (loadValue) {
  return dispatch => {
    dispatch({ type: ShowNumpadForDiscount, payload: loadValue })
  }
}

export function loadShowNumPadForPay (loadValue) {
  return dispatch => {
    dispatch({ type: ShowNumpadForPayment, payload: loadValue })
  }
}

export function loadNumPadType (loadValue) {
  // 1 for quantity, 2 for amount, 3 for discount, 4 for customers
  return dispatch => {
    dispatch({ type: NumPadType, payload: loadValue })
  }
}

export function loadNumRelateData (loadValue) {
  // 1 for quantity, 2 for amount, 3 for discount, 4 for customers
  return dispatch => {
    dispatch({ type: NumRelateData, payload: loadValue })
  }
}

export function loadNumChange (loadValue) {
  // 1 for quantity, 2 for amount, 3 for discount, 4 for customers
  return dispatch => {
    dispatch({ type: NumDataChange, payload: loadValue })
  }
}

export function loadSellAttribTabs (loadValue) {
  // 1 for quantity, 2 for amount, 3 for discount, 4 for customers
  return dispatch => {
    dispatch({ type: MOUNTSELLATTRIBTABS, payload: loadValue })
  }
}

export function loadSellAttribTabs_type (loadValue) {
  // 1 for quantity, 2 for amount, 3 for discount, 4 for customers
  return dispatch => {
    dispatch({ type: MOUNTSELLATTRIBTABS_TYPE, payload: loadValue })
  }
}

export function loadShowQuickKey (loadValue) {
  // 1 for quantity, 2 for amount, 3 for discount, 4 for customers
  return dispatch => {
    dispatch({ type: SHOW_QUICK_KEY, payload: loadValue })
  }
}

//**********SERVICES************

async function outletRegisterService (dispatch, body) {
  const getReg = ds.getOutletsRegistersService(body)
  await getReg
    .then(async response => {
      dispatch(loadRegOutletsLoading(false))
      if (response && response.length > 0) {
        let regData = response.map(e => {
          return {
            id: e.sRegisterID,
            register: e.registerName,
            openedOn: e.openedOn,
            openedOnDate: e.openedOnDate,
            closure: e.closure + 1,
            expected: e.expected,
            printNoteOnReceipt: e.printNoteOnReceipt,
            selectUserForNextSale: e.selectUserForNextSale,
            printReceipt: e.printReceipt,
            showDiscountsOnReceipts: e.showDiscountsOnReceipts,
            prefix: e.prefix,
            suffix: e.suffix,
            number: e.number
          }
        })
        dispatch({ type: OPENCLOSE_OUTLETS_REGISTERS, payload: regData })
        let index_body = {
          config_key: CONFIG_LOGS.OUT_REG,
          data: JSON.stringify(response)
        }
        await saveEntitiesDatatoIndexBD(
          [index_body],
          INDEX_DB_NAME,
          CURRENT_VERSION,
          INDEX_DB_TABLES.CONFIGDATA,
          'outletRegisterService'
        )
      } else {
        dispatch({ type: OPENCLOSE_OUTLETS_REGISTERS, payload: [] })
      }
    })
    .catch(e => {
      dispatch(loadRegOutletsLoading(false))
      if (e.response && e.response.status === 401 && checkExpiresSub() > 0) {
        message.error('Token Expired! Redirecting to Login Page')
        setTimeout(() => {
          dispatch(userLogOut('store.getState()'))
        }, 3000)
      } else {
        // message.error('Something Went Wrong...')
      }
    })
}

async function storeOutletsService (dispatch, isUserAccordingly) {
  const getOutlets = ds.getStoreOutlets(isUserAccordingly)
  await getOutlets
    .then(response => {
      dispatch(loadRegOutletsLoading(false))
      if (response.status == 200) {
        if (response.data.msgCode == 'GENERAL_SUCCESS') {
          if (response.data.data) {
            let data = response.data.data
            let outletData = data.map(e => {
              return {
                id: e.sOutletId,
                // id: e.sOutletId.substring(0, e.sOutletId.indexOf("&")),
                outlet: e.outletName,
                warnForCustomer: e.warnForCustomer
              }
            })
            dispatch({ type: OPENCLOSE_STORE_OUTLETS, payload: outletData })
          } else {
            message.error('Server down, Retry to load Outlets...')
          }
        } else {
          message.error('Server down, Retry to load Outlets...')
        }
      } else {
        message.error('Server down, Retry to load Outlets...')
      }
    })
    .catch(e => {
      if (!checkUserVerifyPage()) {
        dispatch(loadRegOutletsLoading(false))
      }
    })
}

async function closedRegisterService (dispatch, body) {
  dispatch(loadClosedRegLoading(true))
  const getClosedReg = ds.getClosedRegInfoService(body)
  await getClosedReg
    .then(response => {
      dispatch(loadClosedRegLoading(false))
      if (response) {
        let inOutData =
          response.registerInOut && response.registerInOut.length > 0
            ? response.registerInOut.map((e, key) => {
                return {
                  id: key,
                  cashManageID: e.cashManageID,
                  pid: e.pid,
                  user: e.userName,
                  time: e.createdOn,
                  reason: e.reason,
                  amount: e.transaction
                    ? parseFloat(e.transaction)
                    : parseFloat('0.00'),
                  note: e.note,
                  email: e.userEmail,
                  date: e.createdOnDate,
                  nameLetter: e.lettersName,
                  role: e.roleName,
                  closingFloat: e.closingFloat
                    ? parseFloat(e.closingFloat)
                    : parseFloat('0.00')
                }
              })
            : []
        let data = {
          outletRegister: response.outletRegister
            ? response.outletRegister
            : {},
          registerInOut: inOutData,
          outletName: response.outletName ? response.outletName : '',
          currUserName: response.currUserName,
          extraPrinters: response.extraPrinters ? response.extraPrinters : false
        }
        dispatch({ type: OPENCLOSE_CLOSEDREG_DATA, payload: data })
      }
    })
    .catch(e => {
      dispatch(loadClosedRegLoading(false))
    })
}

async function storeUsersService (dispatch) {
  const getUsers = ds.getStoreUsersService()
  await getUsers
    .then(response => {
      // dispatch(loadRegOutletsLoading(false));
      if (response && response.length > 0) {
        dispatch({ type: STORE_USERS, payload: response })
      }
    })
    .catch(e => {})
}

async function sellProductDetailService (
  dispatch,
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  user
) {
  const getProducts = ds.getSaleProductDetailsService(body)
  await getProducts
    .then(response => {
      buildProdForCart(
        response,
        dispatch,
        body,
        prevValue,
        selectedProds,
        outInvWarn,
        user
      )
      // dispatch(loadSellScreenLoading(false))
      // if (response.variants && response.variants.length > 0) {
      //   let prodVar = []
      //   const prods = response.products
      //   if (prods && prods.length > 0) {
      //     prodVar = prods.map(dd => {
      //       return dd.variantName
      //     })
      //   }
      //   dispatch(loadCheckProdsVariants(prodVar))
      //   dispatch({ type: SELL_VARIANTS_PRODUCT, payload: response.variants })
      // }
      // if (response.products && response.products.length > 0) {
      //   if (!body.containVariants) {
      //     let prod = response.products[0]
      //     if (outInvWarn && prod && prod.isProductInventory) {
      //       prod.inventoryCheck = true
      //       if (prod.currentInventory <= 0) {
      //         message.warn(
      //           `You do not have enough inventory for ${prod.productName}`,
      //           4
      //         )
      //         dispatch(loadShowInventoryPopup(true))
      //       }
      //     }
      //     let selectedProdList = selectedProds
      //     selectedProdList = selectedProdList.concat(response.products)
      //     dispatch({ type: SELL_SELECTED_PRODUCTS, payload: selectedProdList })
      //     dispatch(loadSellSelectedSingleProd(prod))
      //   }
      //   let prodStackArray = prevValue
      //   prodStackArray = prodStackArray.concat(response)
      //   dispatch({ type: SELL_PRODUCT_DETAIL, payload: prodStackArray })
      // }
    })
    .catch(e => {
      dispatch(loadIsProductLoading(false))
      dispatch(loadSellScreenLoading(false))
    })
}

async function salePriceBooksService (dispatch, outletID) {
  const getPriceBooks = ds.getSalePriceBooksService(outletID)
  await getPriceBooks
    .then(response => {
      if (response) {
        if (response.pbList && response.pbList.length > 0) {
          dispatch({ type: SALE_PRICEBOOKS, payload: response.pbList })
        }
        if (response.invenotryWarn) {
          dispatch(loadIsOutletInvWarn(true))
        } else {
          dispatch(loadIsOutletInvWarn(false))
        }
      }
    })
    .catch(e => {})
}

async function salePromotionsService (dispatch, outletID) {
  const getPriceBooks = ds.getSalePromotionsService(outletID)
  await getPriceBooks
    .then(response => {
      if (response && response.length > 0) {
        dispatch({ type: SALE_PROMOTIONS, payload: response })
      }
    })
    .catch(e => {})
}

async function getUserSubscriptionInfo (dispatch) {
  const createReq = ds.getUserSubscriptionService()
  await createReq
    .then(res => {
      if (res) {
        dispatch({ type: USER_SUBS_INFO, payload: res })
      }
    })
    .catch(e => {
      //   console.error("createSubPayment", e);
      //   this.setState({
      //     isBillingLoading: false,
      //   });
      //   message.error("Failed, report this & Try later");
    })
}

async function getSellAttributes (dispatch, body) {
  const createReq = ds.getSellAttributesService(body)
  await createReq
    .then(res => {
      dispatch(loadSellAttributeLoading(false))
      if (res && res.length > 0) {
        checkBookedAttrib(res, dispatch)
        // dispatch({ type: SELLATTRIBUTES, payload: res })
      } else {
        dispatch({ type: SELLATTRIBUTES, payload: [] })
      }
    })
    .catch(e => {
      dispatch(loadSellAttributeLoading(false))
      //   console.error("createSubPayment", e);
      //   this.setState({
      //     isBillingLoading: false,
      //   });
      //   message.error("Failed, report this & Try later");
    })
}

async function getSellAttributesGroups (dispatch) {
  const createReq = ds.getSellAttributesService({ GroupID: '' })
  await createReq
    .then(res => {
      if (res && res.length > 0) {
        dispatch({ type: SELLATTRIBUTESGROUPS, payload: res })
      } else {
        dispatch({ type: SELLATTRIBUTESGROUPS, payload: [] })
      }
    })
    .catch(e => {
      //   console.error("createSubPayment", e);
      //   this.setState({
      //     isBillingLoading: false,
      //   });
      //   message.error("Failed, report this & Try later");
    })
}

export function buildProdForCart (
  response,
  dispatch,
  body,
  prevValue,
  selectedProds,
  outInvWarn,
  user
) {
  dispatch(loadSellScreenLoading(false))
  if (response.variants && response.variants.length > 0) {
    let prodVar = []
    const prods = response.products
    if (prods && prods.length > 0) {
      prodVar = prods.map(dd => {
        return dd.variantName
      })
    }
    dispatch(loadCheckProdsVariants(prodVar))
    dispatch({ type: SELL_VARIANTS_PRODUCT, payload: response.variants })
  }
  if (response.products && response.products.length > 0) {
    if (user && user.userID)
      response.products.map(q => (q.userID = getDecryptID(user.userID)))
    if (!body.containVariants) {
      let prod = response.products[0]
      if (outInvWarn && prod && prod.isProductInventory) {
        prod.inventoryCheck = true
        if (prod.currentInventory <= 0) {
          message.warn(
            `You do not have enough inventory for ${prod.productName}`,
            4
          )
          dispatch(loadShowInventoryPopup(true))
        }
      }
      let selectedProdList = selectedProds
      selectedProdList = selectedProdList.concat(response.products)
      dispatch({ type: SELL_SELECTED_PRODUCTS, payload: selectedProdList })
      dispatch(loadSellSelectedSingleProd(prod))
      message.success('Item added to cart')
    }
    let prodStackArray = prevValue
    prodStackArray = prodStackArray.concat(response)
    dispatch({ type: SELL_PRODUCT_DETAIL, payload: prodStackArray })
  }
}

function getOutRegFromIndex (dispatch) {
  const data = GetIndexDBDataByTableName(
    INDEX_DB_NAME,
    INDEX_DB_TABLES.CONFIGDATA
  )
  data
    .then(e => {
      dispatch(loadRegOutletsLoading(false))
      if (e && e.length > 0) {
        const dataExist = e.filter(er => er.config_key == CONFIG_LOGS.OUT_REG)
        if (dataExist && dataExist.length > 0 && dataExist[0].data) {
          const response = JSON.parse(dataExist[0].data)
          let regData = response.map(e => {
            return {
              id: e.sRegisterID,
              register: e.registerName,
              openedOn: e.openedOn,
              openedOnDate: e.openedOnDate,
              closure: e.closure + 1,
              expected: e.expected,
              printNoteOnReceipt: e.printNoteOnReceipt,
              selectUserForNextSale: e.selectUserForNextSale,
              printReceipt: e.printReceipt,
              showDiscountsOnReceipts: e.showDiscountsOnReceipts,
              prefix: e.prefix,
              suffix: e.suffix,
              number: e.number
            }
          })
          dispatch({ type: OPENCLOSE_OUTLETS_REGISTERS, payload: regData })
        } else {
          dispatch({ type: OPENCLOSE_OUTLETS_REGISTERS, payload: [] })
        }
      } else {
        console.error(
          'INDEX_DB_DATA_NOT_FOUND -> INDEX_DB_TABLES.CONFIGDATA -->',
          e
        )
      }
    })
    .catch(e => {
      dispatch(loadRegOutletsLoading(false))
      console.error('INDEX_DB_CONFIGS_ERROR -> getTemplatesFromIndex -->', e)
    })
}

function checkBookedAttrib (res, dispatch) {
  const data = GetIndexDBDataByTableName(INDEX_DB_NAME, INDEX_DB_TABLES.SALES)
  data
    .then(e => {
      let data = [...res]
      if (e && e.length > 0) {
        const salesExist = e.filter(
          q =>
            q.isParked &&
            q.isOffline &&
            q.sellAttributes &&
            q.sellAttributes.length > 0
        )
        const completedOffline = e.filter(
          q =>
            (q.isOffline && q.isCompleted) ||
            getDecryptID(q.e_SalesOrderStatusID) ==
              getDecryptID(fetchCurrentSalesOrder('Voided'))
        )
        if (completedOffline && completedOffline.length > 0) {
          completedOffline.map(qww => {
            if (data && data.length > 0) {
              data.map(aa => {
                if (aa.sales && aa.sales.length > 0) {
                  const salesLength = aa.sales.length
                  aa.sales = aa.sales.filter(dd => dd.indexKey != qww.indexKey)
                  if (salesLength > aa.sales.length) {
                    aa.saleCount -= 1
                    aa.saleOrderID = '--'
                  }
                  if (aa.sales.length == 0) {
                    aa.inProgress = false
                  }
                }
              })
            }
          })
        }
        if (salesExist && salesExist.length > 0) {
          salesExist.map(ee => {
            if (data && data.length > 0) {
              data.map(ww => {
                const sales = ee.sellAttributes.filter(
                  xx =>
                    getDecryptID(xx.attributeID) ==
                      getDecryptID(ww.attributeID) &&
                    getDecryptID(xx.groupID) == getDecryptID(ww.groupID)
                )
                if (sales && sales.length > 0) {
                  const body = {
                    amount: ee.totalPrice,
                    createdOn: ee.operateDateTime,
                    receiptCode: ee.receiptCode,
                    saleOrderID: '',
                    isOffline: ee.indexKey,
                    indexKey: ''
                    // index_isAllPaid: ee.isAllPaid
                  }
                  // if (ww.sales && ww.sales.length > 0) {
                  //   ww.sales = ww.sales.filter(ss => ss.indexKey != ee.indexKey)
                  // } else {
                  //   ww.createdOn = ee.operateDateTime
                  // }
                  // ww.sales.push(body)
                  // ww.inProgress = true
                  // ww.amount += ee.totalPrice
                  // ww.saleCount = ww.sales && ww.sales.length > 0 ? ww.sales.length : 0
                  // ww.isOffline = ee.indexKey
                  let saleExistServer = false
                  if (ww.sales && ww.sales.length > 0) {
                    saleExistServer = ww.sales.filter(
                      gf => gf.indexKey == ee.indexKey
                    )
                    saleExistServer = saleExistServer.length > 0 ? true : false
                  }
                  if (ee.isAllPaid) {
                    // ww.amount -= ee.totalPrice
                    // if (ww.amount < 0) ww.amount = 0
                    ww.saleCount = saleExistServer
                      ? ww.saleCount - 1
                      : ww.saleCount
                    ww.inProgress = ww.saleCount > 0 ? true : false
                    // ww.isOffline = ee.indexKey
                  } else {
                    ww.sales.push(body)
                    // ww.amount += ee.totalPrice
                    ww.saleCount = !saleExistServer
                      ? ww.saleCount + 1
                      : ww.saleCount
                    ww.inProgress = ww.saleCount > 0 ? true : false
                    ww.isOffline = ee.indexKey

                    ww.createdOn =
                      ww.saleCount == 1 ? ee.operateDateTime : ww.createdOn
                  }
                }
              })
            }
          })
        }
      }
      dispatch({ type: SELLATTRIBUTES, payload: data })
    })
    .catch(e => {
      dispatch({ type: SELLATTRIBUTES, payload: res })
      console.log(
        'INDEX_DB_ERROR -> checkBookedAttrib, check attribute parked offline sale -->',
        e
      )
    })
}
